<template>
  <div class="page-box">
    <!-- 头部标题 +++++++++++++++++++++++++++++++++++++++++ -->
    <div class="dtl-head">
      <div class="pageTit c-breadcrumb">
        <el-breadcrumb separator=">" class="theme-default">
          <el-breadcrumb-item :to="{ path: '/newriskmanage' }">{{ $t('head.applyWind') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('rongzisqs.titleName') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--流水号-->
      <p class="top-tit" style="text-align:right;padding-right:90px;width:unset"><span>{{ $t('loan.financingNum') }}：</span>
        <span>{{ infoData.zmaFinancingManagementVO.flowNumber }}</span>
      </p>
      <!-- 分割图片 -->
      <img class="c-divider" src="../../assets/images/common/documentSeparation.png" alt="">
    </div>

    <!-- 基本信息++++++++++++++++++++++ -->
    <div class="rongzisqs">

      <!-- 信息分类模块++++++++++++++++++++++++++++++++++++ -->
      <div class="apllyBox">
        <div class="tagsBox">
          <p :class="baseInfo ? 'active' : ''" @click="switchBaseInfo(true)">{{ $t('rongzisqs.baseinfo') }}</p>
        </div>
        <!-- 申请基本信息 -->
        <div v-show="baseInfo">
          <!-- 基础信息 (贸易信息，融资基础信息)-->
          <baseinfoOne :sub-base-data="infoData.cicFinancingApplyDraftSnapshotVO"/>
        </div>
      </div>
    </div>
    <!-- 融资汇总资料 -->
    <div class="tywrzhz">
      <!--当前融资情况-->
      <div class="tywrzhz-rzxxBox">
        <div class="rongzisqs-title">
          <p class="rongzisqs-xb"/>
          {{ $t('rongzisqs.nowFinancingInfo') }}
        </div>
        <!--当前欠款-->
        <strong style="line-height: 60px;color:#333333;font-weight:normal">{{ $t('rongzisqs.arrears') }}： {{ infoData.currentOverDraftUnit }} {{ infoData.currentOverDraft | formatNum }}</strong>
      </div>
      <!-- 最近10笔融资申请 -->
      <div class="tywrzhz-rzxxBox">
        <div class="rongzisqs-title">
          <p class="rongzisqs-xb"/>
          {{ $t('rongzisqs.financeAppRecord') }}
        </div>
        <el-table v-if="infoData.recentTenZmaFmOrderVoList.length" :data="infoData.recentTenZmaFmOrderVoList.slice((listFinalParagram.pageNo- 1)*5,listFinalParagram.pageNo*5)" class="themeBlue" style="width: 100%">
          <el-table-column :label="$t('rongzisqs.financeFlowNumber')" prop="flowNumber" align="center" width="170"/>
          <el-table-column :label="$t('rongzisqs.financeAppCreateTime')" align="center" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.applyTime | dateConvert }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('rongzisqs.financeStEnTime')" prop="financingEndDate" align="center" width="350">
            <template slot-scope="scope">
              <span v-if="scope.row.estimateStartDate">{{ scope.row.estimateStartDate | dateConvertDoit }}-{{ scope.row.estimateEndDate | dateConvertDoit }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('rongzisqs.financeMoney')" align="center" width>
            <template slot-scope="scope">
              <span>{{ scope.row.applyMoneyType }} {{ scope.row.applyMoney | formatNum }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="statusEmptyOneLine">
          <!--暂无数据-->
          {{ $t('frontPage.noData') }}
        </div>
        <el-pagination
          v-if="infoData.recentTenZmaFmOrderVoList.length>5"
          :current-page.sync="listFinalParagram.pageNo"
          :total="infoData.recentTenZmaFmOrderVoList.length"
          :page-size.sync="listFinalParagram.pageSize"
          background
          layout="prev, pager, next"
          class="page-theme"
          style="text-align: center;padding-top:30px; padding-bottom: 30px; "
          @current-change="current_change"/>
      </div>
      <!--  最近10笔订单 -->
      <div class="tywrzhz-jyxxBox">
        <div class="rongzisqs-title">
          <p class="rongzisqs-xb"/>
          {{ $t('rongzisqs.lastOrder') }}
        </div>
        <el-table v-if="infoData.recentTenCicOrderVoList.length" :data="infoData.recentTenCicOrderVoList.slice((listOrderParagram.pageNo- 1)*5,listOrderParagram.pageNo*5)" class="themeBlue" style="width: 100%">
          <el-table-column :label="$t('financingApplication.orderNumber')" prop="orderCode" align="center" width="175"/>
          <el-table-column :label="$t('rongzisqs.productName')" prop="productName" align="center" width="170"/>
          <el-table-column :label="$t('financingApplication.price')" align="center" width>
            <template slot-scope="scope">
              <span>{{ scope.row.referencePrice | formatNum }} {{ scope.row.referencePriceUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('financingApplication.num')" align="center" width>
            <template slot-scope="scope">
              <span>{{ scope.row.quantity | formatNum }} {{ scope.row.quantityUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('poolOfMoney_page.moneyNum')" align="center" width>
            <template slot-scope="scope">
              <span>{{ scope.row.contractPriceUnitName }} {{ scope.row.contractPrice | formatNum }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('loan.tradeTerms')" prop="priceType" align="center" width="100"/>
          <el-table-column :label="$t('rongzisqs.paymentMethod')" prop="paymentMethod" align="center" width="100"/>
        </el-table>
        <div v-else class="statusEmptyOneLine">
          <!--暂无数据-->
          {{ $t('frontPage.noData') }}
        </div>
        <el-pagination
          v-if="infoData.recentTenCicOrderVoList.length>5"
          :current-page.sync="listOrderParagram.pageNo"
          :total="infoData.recentTenCicOrderVoList.length"
          :page-size.sync="listOrderParagram.pageSize"
          background
          layout="prev, pager, next"
          class="page-theme"
          style="text-align: center;padding-top:30px; padding-bottom: 30px; "
          @current-change="currentOrder_change"/>
      </div>
    </div>

    <!-- 融资用户及产品评级 -->
    <div class="tywjycp">
      <div class="ziliaopj">
        <!-- 融资交易用户评级 -->
        <div class="rongzisqs-title">
          <p class="rongzisqs-xb"/>
          <!-- {{$t('financingFundDetail.customerLevel')}}-->
          {{ $t('newrisk.risk_assessment') }}
          <Sbutton
            v-if="wareCode && isCpSwitch"
            style="margin-top:12px;float:right;"
            @click.native="viewProdTrade">{{ $t('btns.productTrade') }}</Sbutton>
        </div>
        <commondity-list v-if="showChart && wareCode && isCpSwitch && !isFirst" ref="commodityChart" style="margin-bottom: 20px" @toggleClick = "toggleCommidity"/>
        <div v-show="showBuyerRiskDiv()" class="ziliaopj-yonghuTags">
          <p class="ziliaopj-yonghutag">
            <span>{{ $t('loan.buyerCompany') }}：{{ infoData.cicFinancingApplyDraftSnapshotVO.buyerCompanyName }}</span>
            <span v-if="newscore.buyerScore">{{ $t('loan.userRate') }}：{{ newscore.buyerScore }}</span>
          </p>
        </div>
        <div v-show="showBuyerRiskDiv()" class="ziliaopj-jyyhpjBox">
          <div ref="buyerCharts" style="position:absolute;left:0;width:860px;height:260px;"/>
          <!-- 等级显示 -->
          <div class="ziliaopj-dengji">
            <el-checkbox v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter" v-model="buyerRisk">{{ $t('newrisk.no_rate') }}</el-checkbox>
            <Sbutton
              v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter"
              :disabled="buyerRisk"
              style="margin-top:30px;width:100px;"
              @click.native="buyerRisk?'':changeLevel(1)"
            >{{ $t('loan.rate') }}</Sbutton>
            <Sbutton
              v-else
              style="margin-top:30px;width:100px;"
              @click.native="checkLevel(1)"
            >{{ $t('financingAppliForm.lookDetails') }}</Sbutton>
          </div>
        </div>
        <div v-show="showSellerRiskDiv()" class="ziliaopj-yonghuTags">
          <p class="ziliaopj-yonghutag">
            <span>{{ $t('loan.salerCompany') }}：{{ infoData.cicFinancingApplyDraftSnapshotVO.sellerCompanyName }}</span>
            <span v-if="newscore.sellerScore">{{ $t('loan.userRate') }}：{{ newscore.sellerScore }}</span>
          </p>
        </div>
        <div v-show="showSellerRiskDiv()" class="ziliaopj-jyyhpjBox">
          <div ref="selleCharts" style="position:absolute;left:0;width:860px;height:260px;"/>
          <!-- 等级显示 -->
          <div class="ziliaopj-dengji">
            <el-checkbox v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter" v-model="sellerRisk">{{ $t('newrisk.no_rate') }}</el-checkbox>
            <Sbutton
              v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter"
              :disabled="sellerRisk"
              style="margin-top:30px;width:100px;"
              @click.native="sellerRisk?'':changeLevel(2)"
            >{{ $t('loan.rate') }}</Sbutton>
            <Sbutton
              v-else
              style="margin-top:30px;width:100px;"
              @click.native="checkLevel(2)"
            >{{ $t('financingAppliForm.lookDetails') }}</Sbutton>
          </div>
        </div>
        <div v-show="infoData.iscoalCategory && showCategoryRiskDiv()" class="ziliaopj-yonghuTags">
          <p :style="!showSellerRiskDiv()?'justify-content: space-between;':'justify-content: flex-end;'" class="ziliaopj-yonghutag">
            <span v-if="!showSellerRiskDiv()">{{ $t('loan.salerCompany') }}：{{ infoData.cicFinancingApplyDraftSnapshotVO.sellerCompanyName }}</span>
            <span v-if="newscore.categoryScore">{{ $t('newrisk.additional_assessment') }}：{{ newscore.categoryScore }}</span>
          </p>
        </div>
        <div v-show="infoData.iscoalCategory && showCategoryRiskDiv()" class="ziliaopj-jyyhpjBox">
          <div ref="categoryCharts" style="position:absolute;left:0;width:860px;height:260px;"/>
          <!-- 等级显示 -->
          <div class="ziliaopj-dengji">
            <el-checkbox v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter" v-model="categoryRisk">{{ $t('newrisk.no_rate') }}</el-checkbox>
            <Sbutton
              v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter"
              :disabled="categoryRisk"
              style="margin-top:30px;width:100px;"
              @click.native="categoryRisk?'':changeLevel(3)"
            >{{ $t('loan.rate') }}</Sbutton>
            <Sbutton
              v-else
              style="margin-top:30px;width:100px;"
              @click.native="checkLevel(3)"
            >{{ $t('financingAppliForm.lookDetails') }}</Sbutton>
          </div>
        </div>
      </div>

      <!-- 风控审核记录 -->
      <AuditLogInfoList v-if="infoData.riskAuditLogList.length" :data="Array.isArray(infoData.riskAuditLogList) ? infoData.riskAuditLogList : []"/>
    </div>
    <div v-if="infoData.zmaFinancingManagementVO.applicationStatus == 4 && isShowFooter" class="whiteFixed">
      <!--打回，提交，转移-->
      <Tbutton style="margin:0 10px;min-width:150px;display: inline-block;" @click.native="showShenhe('2')">{{ $t('btns.repulse') }}</Tbutton>
      <Tbutton style="margin:0 10px;width:150px;display: inline-block;" @click.native="showShenhe('1')">{{ $t('btns.submit') }}</Tbutton>
      <Tbutton v-if="infoData.isCic" style="margin:0 10px;width:150px;display: inline-block;" @click.native="showShenhe('8')">{{ $t('btns.transfer') }}</Tbutton>
    </div>
    <!--通过，打回-->
    <div v-if="infoData.zmaFinancingManagementVO.applicationStatus == 5 && isShowFooter" class="whiteFixed">
      <Tbutton style="margin:0 10px;min-width:150px;display: inline-block;" @click.native="showShenhe('4')">{{ $t('btns.repulse') }}</Tbutton>
      <Tbutton style="margin:0 10px;width:150px;display: inline-block;" @click.native="showShenhe('3')">{{ $t('btns.pass') }}</Tbutton>
    </div>
    <div v-if="infoData.zmaFinancingManagementVO.applicationStatus == 6 && isShowFooter" class="whiteFixed">
      <!--打回，拒绝，通过-->
      <Tbutton style="margin:0 10px;min-width:150px;display: inline-block;" @click.native="showShenhe('6')">{{ $t('btns.repulse') }}</Tbutton>
      <Tbutton style="margin:0 10px;width:150px;display: inline-block;" @click.native="showShenhe('7')">{{ $t('btns.refuse') }}</Tbutton>
      <Tbutton style="margin:0 10px;width:150px;display: inline-block;" @click.native="showShenhe('5')">{{ $t('btns.pass') }}</Tbutton>
    </div>
    <!-- 评级弹出层 -->
    <div v-show="pingjiShow" class="pingjiPopup">
      <div class="pingjiBox">
        <div class="pingjiPopup-title">
          {{ $t('rongzisqs.changeLevel') }}
          <i class="el-icon-close pingjiPopup-close" @click="closePingjiPopup"/>
        </div>
        <p style="line-height:32px;text-align:center;color:#666666;">{{ $t('rongzisqs.levelSoccer') }}</p>
        <p style="line-height:48px;text-align:center;color:#7996F5;font-size: 24px;">{{ soccer }}</p>
        <div class="pingjiPopup-block">
          <span class="demonstration"/>
          <el-slider v-model="soccer" :min="1" :max="5" :step="1" show-stops/>
        </div>
        <p style="width:440px;margin:0 auto;display:flex;justify-content:space-between;">
          <span>1</span>
          <span>2</span>
          <span>3</span>
          <span>4</span>
          <span>5</span>
        </p>
        <div class="pingjiPopup-des">
          <span v-if="soccer == 1 && pingjiObj == 'prod'">{{ $t('productLevel.1') }}</span>
          <span v-if="soccer == 2 && pingjiObj == 'prod'">{{ $t('productLevel.2') }}</span>
          <span v-if="soccer == 3 && pingjiObj == 'prod'">{{ $t('productLevel.3') }}</span>
          <span v-if="soccer == 4 && pingjiObj == 'prod'">{{ $t('productLevel.4') }}</span>
          <span v-if="soccer == 5 && pingjiObj == 'prod'">{{ $t('productLevel.5') }}</span>
          <span v-if="soccer == 1 && pingjiObj == 'user'">{{ $t('customerLevel.1') }}</span>
          <span v-if="soccer == 2 && pingjiObj == 'user'">{{ $t('customerLevel.2') }}</span>
          <span v-if="soccer == 3 && pingjiObj == 'user'">{{ $t('customerLevel.3') }}</span>
          <span v-if="soccer == 4 && pingjiObj == 'user'">{{ $t('customerLevel.4') }}</span>
          <span v-if="soccer == 5 && pingjiObj == 'user'">{{ $t('customerLevel.5') }}</span>
        </div>
        <div class="pingjiPopup-saveBox">
          <Tbutton style="width:150px;margin:0 auto;" @click.native="saveLevel(pingjiObj)">{{ $t('rongzisqs.levelSoccer') }}</Tbutton>
        </div>
      </div>
    </div>
    <!-- 审核通过拒绝弹出层 -->
    <VerifyPopup
      v-if="isShow"
      :title="shenheTitle"
      :transfer="transfer"
      :options="options"
      :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')"
      maxlength="300"
      @cancel="hide('isShow')"
      @confirm="submit"
    />

  </div>
</template>

<script>
const echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/line')
// // 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
import dayjs from 'dayjs'
import mixins from '@/helper/mixins.js'
import AuditLogInfoList from '../../components/auditLogInfoList'
import baseinfoOne from '../../components/pageDtl/baseInfoOne'
import Tbutton from '../../components/Tbutton'
import Sbutton from '../../components/Sbutton'
import ConfirmPopup from '../../components/ConfirmPopup'
import VerifyPopup from '../../components/VerifyPopup'
import commondityDialog from '../../components/commondityDialog'
import commondityList from '@/components/KLineCommondity/index.vue'
import { mapState } from 'vuex'
export default {
  name: 'Ziliaopj',
  components: {
    Tbutton,
    Sbutton,
    VerifyPopup,
    ConfirmPopup,
    baseinfoOne,
    AuditLogInfoList,
    commondityDialog,
    commondityList
  },
  mixins: [mixins],
  data() {
    return {
      listFinalParagram: {
        pageNo: 1,
        pageSize: 5
      },
      listOrderParagram: {
        pageNo: 1,
        pageSize: 5
      },
      options: [],
      isShowFooter: false,
      id: this.$route.query.id || '',
      islock: false,
      menuMsg: {
        path: '',
        name: ''
      },
      menuType: this.$route.query.menuType || '', // 来源菜单类型 1申请风控 2资金锁定 3贷款发放 4贷后跟踪 5资金池 6全部订单
      infoData: {
        zmaFinancingManagementVO: {
          flowNumber: '',
          applyCompany: '', // 申请公司名字
          applicationStatus: ''// 1.待修改 2.修改待确认 3.融资关闭 4.风控审核中 5.风控一审中 6.风控二审中 7.风控拒绝8.风控通过
        },
        cicFinancingApplyDraftSnapshotVO: {}, // 贸易信息等融资子表信息
        currentOverDraft: '', // 当前欠款
        currentOverDraftUnit: '', // 当前欠款单位
        isCic: 0, // 是否是CIC公司 1 是   0 不是
        recentTenZmaFmOrderVoList: [], // 最近10笔融资申请
        recentTenCicOrderVoList: [], // 最近10笔订单
        riskAuditLogList: [], // 风控审核日志集合
        userChart: [{ createTime: '' }],
        productChart: [{ createTime: '' }]
      },
      baseInfo: true,
      // 显示评分弹出层
      pingjiShow: false,
      // 评级对象
      pingjiObj: '',
      // 是否通过提交拒绝等弹出层显示
      isShow: false,
      // 分数
      soccer: 1,
      shenheTitle: '',
      isPass: '', // 1:审核中提交2:审核中打回3:一审通过4:一审打回5:二审通过6:二审打回7:二审拒绝8:转移
      operateBtn: {
        '1': '/api/zma/risk/zmaRiskAuditingCommit',
        '2': '/api/zma/risk/zmaRiskAuditingBack',
        '3': '/api/zma/risk/zmaRiskFirstAuditPass',
        '4': '/api/zma/risk/zmaRiskFirstAuditBack',
        '5': '/api/zma/risk/zmaRiskSecondAuditPass',
        '6': '/api/zma/risk/zmaRiskSecondAuditBack',
        '7': '/api/zma/risk/zmaRiskSecondAuditRefuse',
        '8': '/api/zma/risk/zmaTransferLoanComany'
      },
      transfer: false, // transfer为true，是否通过审核弹框textarea变为select框，只有转移出现

      wareCode: '', // 商品走势code，商品配置了交易所才显示 (1.1) ，有code就显示 按钮
      showChart: '', // 商品走势列表是否显示
      isCpSwitch: false, // 商品走势开关
      isFirst: true, // 是否是第一次进入，第一次进入的时候不显示商品走势列表
      // new
      newscore: {},
      buyerRisk: false,
      sellerRisk: false,
      categoryRisk: false
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  created() {
    this.getInfo()
    if (this.menuType == 3) {
      this.menuMsg.path = '/financingExamineList'
      this.menuMsg.name = this.$t('loanApplication.loanpayment')
    } else if (this.menuType == 4) {
      this.menuMsg.path = '/afterLoanList'
      this.menuMsg.name = this.$t('loanApplication.loanfollow')
    } else if (this.menuType == 6) {
      this.menuMsg.path = '/allorders'
      this.menuMsg.name = this.$t('head.allOrder')
    } else if (this.menuType == 1) {
      this.menuMsg.path = '/newriskmanage'
      this.menuMsg.name = this.$t('head.applyWind')
    }
  },
  mounted() {
    const isSuper = this.isSuper()
    if (isSuper) { // 如果是超级管理员 所有的权限都会有
      this.isShowFooter = true
    } else {
      this.getBtnLimit(this.id).then(data => {
        if (data.type) {
          this.isShowFooter = true
        } else {
          this.isShowFooter = false
        }
      }) // 获取系统按钮权限
    }
    document.title = this.$t('head.applyWind')
  },
  methods: {
    showBuyerRiskDiv() {
      if (this.infoData.zmaFinancingManagementVO.applicationStatus == 4) {
        return true
      }
      if (this.infoData.zmaFinancingManagementVO.buyerRisk) {
        return true
      }
      return false
    },
    showSellerRiskDiv() {
      if (this.infoData.zmaFinancingManagementVO.applicationStatus == 4) {
        return true
      }
      if (this.infoData.zmaFinancingManagementVO.sellerRisk) {
        return true
      }
      return false
    },
    showCategoryRiskDiv() {
      if (this.infoData.zmaFinancingManagementVO.applicationStatus == 4) {
        return true
      }
      if (this.infoData.zmaFinancingManagementVO.categoryRisk) {
        return true
      }
      return false
    },
    toggleCommidity() {
      this.$nextTick(() => {
        this.$refs.commodityChart.resetList()
      })
      this.showChart = false
    },

    current_change: function(pageNo) {
      this.listFinalParagram.pageNo = pageNo
    },
    currentOrder_change: function(pageNo) {
      this.listOrderParagram.pageNo = pageNo
    },
    zmaLoanList() {
      const param = {
        flowNumber: this.infoData.zmaFinancingManagementVO.flowNumber
      }
      this.axios.post('/api/zma/risk/zmaLoanList', param).then(res => {
        if (res.status) {
          this.options = res.data
        } else {
          if (res.errorCode == 'loan_audit_50000031') {
            this.$router.push(this.menuMsg.path)
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`))
          }
        }
      })
    },
    hide(value) {
      if (value == 'isShow') {
        this.transfer = false
        this.isShow = false
      }
    },
    submit(val) {
      if (this.islock) return
      this.operateBtnMethod(val)
    },
    // 基本信息和附加信息切换
    switchBaseInfo(value) {
      this.baseInfo = value
    },

    initCommodity() {
      if (this.isCpSwitch && this.showChart && this.wareCode && !this.isFirst) {
        const param = {
          wareCode: this.wareCode
        }
        this.$nextTick(() => {
          this.$refs.commodityChart.handleInit(param)
        })
      }
    },

    getqlSwitch() {
      const _this = this
      _this.axios.post('/zmacommon/getqlSwitch', {}).then((res) => {
        if (res.status) {
          _this.isCpSwitch = res.data === 1
          _this.initCommodity()
        }
      })
    }, // 获取商品走势列表展示开关
    getInfo() {
      this.axios
        .post('/api/zma/risk/zmaRiskDetail', { flowNumber: this.id })
        .then(res => {
          if (res.status) {
            this.infoData = res.data
            this.wareCode = res.data.zmaFinancingManagementVO.wareCode // 商品走势图code
            this.showChart = !!this.wareCode // 是否显示商品走势
            if (this.showChart) {
              this.getqlSwitch()
            }
            this.userCharts('buyerCharts', this.infoData.buyerLevelList)
            this.userCharts('selleCharts', this.infoData.sellerLevelList)
            if (this.infoData.iscoalCategory) {
              this.$nextTick(() => {
                this.userCharts('categoryCharts', this.infoData.categoryLevelList)
              })
            }
          } else {
            if (res.errorCode == 'loan_audit_50000031') {
              this.$router.push(this.menuMsg.path)
            } else {
              this.$message.error(this.$t(`error.${res.errorCode}`))
            }
          }
        })
      this.axios.post('/api/zma/risk/getZmaRiskScoreByFlowNum', { flowNumber: this.id }).then(res => {
        if (res.status) {
          this.newscore = res.data
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    },
    sameReturn(res) {
      if (res.status) {
        this.$router.push(this.menuMsg.path)
      } else {
        if (res.errorCode == 'loan_audit_50000031') {
          this.$router.push(this.menuMsg.path)
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      }
    },
    operateBtnMethod(val) {
      if (this.isPass == '8') {
        // 理由不能为空
        if (val == '') {
          this.$message.error(this.$t('rongzisqs.pleasechoosecompany'))
          return false
        }
        this.islock = true
        this.axios.post(this.operateBtn[this.isPass], { needTransferLoanId: val, flowNumber: this.infoData.zmaFinancingManagementVO.flowNumber }).then(res => {
          this.islock = false
          this.sameReturn(res)
        })
      } else if ((this.isPass == '1') || (this.isPass == '2')) {
        const paramas = {
          productRatingLevel: this.infoData.zmaFinancingManagementVO.productRatingLevel,
          auditOpinion: val,
          flowNumber: this.infoData.zmaFinancingManagementVO.flowNumber,
          companyRatingLevel: this.infoData.zmaFinancingManagementVO.companyRatingLevel

        }
        if (this.isPass == '1') {
          // // 用户评级不能为空
          // if (this.infoData.zmaFinancingManagementVO.companyRatingLevel == '') {
          //   this.$message.error(this.$t('rongzisqs.loan_risk_800030'))
          //   return false
          // }
          // // 商品评级不能为空
          // if (this.infoData.zmaFinancingManagementVO.productRatingLevel == '') {
          //   this.$message.error(this.$t('rongzisqs.loan_risk_800031'))
          //   return false
          // }
          paramas.buyerRisk = this.buyerRisk ? 0 : 1
          paramas.sellerRisk = this.sellerRisk ? 0 : 1
          paramas.categoryRisk = (this.categoryRisk || !this.infoData.iscoalCategory) ? 0 : 1
        }
        if (this.isPass == '2') {
          // 理由不能为空
          if (val == '') {
            this.$message.error(this.$t('rongzisqs.reason'))
            return false
          }
        }
        this.islock = true
        this.axios.post(this.operateBtn[this.isPass], paramas).then(res => {
          this.islock = false
          this.sameReturn(res)
        })
      } else {
        // 理由不能为空
        if ((val == '') && ((this.isPass == '4') || (this.isPass == '6') || (this.isPass == '7'))) {
          this.$message.error(this.$t('rongzisqs.reason'))
          return false
        }
        this.islock = true
        this.axios.post(this.operateBtn[this.isPass], { auditOpinion: val, flowNumber: this.infoData.zmaFinancingManagementVO.flowNumber }).then(res => {
          this.islock = false
          this.sameReturn(res)
        })
      }
    },
    // 显示审核弹窗
    showShenhe(type) {
      if ((type == '2') || (type == '4') || (type == '6')) {
        this.shenheTitle = this.$t('popTitle.sureRepulse')
      } else if (type == '1') {
        this.shenheTitle = this.$t('popTitle.sureSubmit')
      } else if ((type == '3') || (type == '5')) {
        this.shenheTitle = this.$t('popTitle.surePass')
      } else if (type == '7') {
        this.shenheTitle = this.$t('popTitle.sureReview')
      } else if (type == '8') {
        this.zmaLoanList()
        this.shenheTitle = this.$t('popTitle.suretransfer')
        this.transfer = true
      }
      this.isPass = type
      this.isShow = true
    },
    // 融资交易用户评级
    userCharts(ref, dataSouce) {
      const userCharts = echarts.init(this.$refs[ref])
      const xData = []
      const yData = []
      if (dataSouce.length == 1) {
        xData.push(0)
        xData.push(
          dayjs(dataSouce[0].createTime).format('YYYY-MM-DD')
        )
      } else if (dataSouce.length < 1) {
        console.log('暂无数据')
      } else {
        for (let i = 0; i < dataSouce.length; i++) {
          xData.push(
            dayjs(dataSouce[i].createTime).format('YYYY-MM-DD')
          )
        }
      }
      if (dataSouce.length == 1) {
        yData.push(0)
        yData.push(dataSouce[0].ratingLevelnew)
      } else if (dataSouce.length < 1) {
        console.log('暂无数据')
      } else {
        for (let i = 0; i < dataSouce.length; i++) {
          yData.push(dataSouce[i].ratingLevelnew)
        }
      }
      userCharts.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          show: true,
          top: '20px',
          left: '8px',
          right: '70px',
          bottom: '20px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData,
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#f8f8f8'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          axisLabel: { show: true, align: 'left', textStyle: { color: '#EAEAEA' }}
        },
        yAxis: {
          type: 'value',
          position: 'right',
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#f8f8f8'],
              width: 1,
              type: 'solid'
            }
          },
          axisLabel: { show: true, textStyle: { color: '#EAEAEA' }}
        },
        series: [
          {
            data: yData,
            type: 'line',
            itemStyle: {
              color: '#7996F5',
              borderWidth: 2
            },
            lineStyle: {
              color: '#7996F5'
            },
            symbolSize: 12
          }
        ]
      })
    },

    // 评级
    changeLevel(type) {
      if (type != 3) {
        this.$router.push(`/riskAssessment?id=${this.id}&riskType=${type}&menuType=${this.menuType}`)
      } else {
        this.$router.push(`/riskCoal?id=${this.id}&riskType=${type}&menuType=${this.menuType}`)
      }
    },
    checkLevel(type) {
      if (type != 3) {
        this.$router.push(`/riskAssessmentDetail?id=${this.id}&riskType=${type}&menuType=${this.menuType}`)
      } else {
        this.$router.push(`/riskCoalDetail?id=${this.id}&riskType=${type}&menuType=${this.menuType}`)
      }
    },
    closePingjiPopup() {
      this.pingjiShow = false
    },
    // 保存评级
    saveLevel(value) {
      if (value === 'user') {
        this.infoData.zmaFinancingManagementVO.companyRatingLevel = this.soccer
      } else {
        this.infoData.zmaFinancingManagementVO.productRatingLevel = this.soccer
      }
      this.pingjiShow = false
    },

    viewProdTrade() {
      // console.log("查看商品走势");
      // this.$refs.commondityChartDialog.show(this.wareCode)
      this.showChart = true
      this.isFirst = false
      this.initCommodity()
    } //  查看商品走势 弹框
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep.el-table__header,::v-deep.el-table__body{
    width: 100% !important;
  }
  ::v-deep.el-table th.is-leaf{
    border-bottom: none;
  }
.rongzisqs {
  font-size: 14px;
  border-radius: 4px;
  overflow: hidden;
  margin-top: -5px;
  .tagsBox {
    width: 1200px;
    height: 45px;
    line-height: 45px;
    padding: 0 90px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: inset 0 -1px 0 0 #dddddd;
    p {
      width: 240px;
      height: 45px;
      color: #81899e;
      text-align: center;
      margin-right: 20px;
      box-sizing: border-box;
      background: #f6f6f8;
      border: 1px solid #dddddd;
      border-radius: 4px 4px 0px 0px;
      cursor: pointer;
      display: inline-block;
    }
    p.active {
      color: #7996f5;
      background: #ffffff;
      border-bottom: none;
    }
  }
  .baseInfoBox {
    .base1info {
      padding: 15px 0;
    }
    &-row1 {
      height: 30px;
      line-height: 30px;
    }
    &-colleft,
    &-colright {
      display: inline-block;
    }
    &-colleft {
      width: 250px;
    }
    &-row2 {
      // height: 40px;
      line-height: 40px;
      padding: 5px 0;
    }
    &-shenhe {
      padding: 10px 0;
    }
  }
  &-title {
    height: 55px;
    line-height: 55px;
    box-shadow: inset 0 -1px 0 0 #eaeaea;
    overflow: hidden;
  }
  &-xb {
    width: 2px;
    margin: 21px 10px 0 0;
    height: 14px;
    float: left;
    background: #7996f5;
    border-radius: 2px;
  }
  &-download {
    color: #7996f5;
  }
  &-download:hover {
    color: #8ca6fd;
  }
}
.ziliaopj {
  font-size: 14px;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
  &-financingFileList {
    .tr1 {
      color: #828baf;
      height: 50px;
      line-height: 50px;
      background: #f8fafd;
    }
    .tr2 {
      color: #606266;
      height: 60px;
      line-height: 60px;
      box-shadow: inset 0 -1px 0 0 #eaeaea;
    }
    .td1-1 {
      width: 290px;
      padding-left: 20px;
      a {
        color: #7996f5;
      }
      a:hover {
        color: #8ca6fd;
      }
    }
    .td1-2 {
      width: 600px;
      padding-left: 20px;
      a {
        color: #7996f5;
      }
      a:hover {
        color: #8ca6fd;
      }
    }
    .td2-1 {
      width: 270px;
      padding-left: 20px;
    }
    .td2-2 {
      width: 180px;
      padding-left: 20px;
    }
    .td3-1 {
      width: 200px;
      padding-left: 20px;
    }
    .td3-2 {
      width: 180px;
      padding-left: 20px;
    }
    .td4 {
      text-align: center;
      width: 200px;
      cursor: pointer;
      color: #7996f5;
    }
    .td4:hover {
      color: #8ca6fd;
    }
    td {
      overflow: hidden;
    }
  }
  &-uploadbtn {
    position: relative;
    display: block;
    min-width: 120px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    background: #7996f5;
    border-radius: 19px;
    outline: none;
    color: #fff;
    text-align: center;
    input {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 120px;
      height: 30px;
      opacity: 0;
      cursor: pointer;
    }
    &-uploadbtn:hover {
      background: #8ca6fd;
    }
  }
  &-handle {
    color: #7996f5;
    cursor: pointer;
    span {
      margin: 10px;
    }
    span:hover {
      color: #8ca6fd;
    }
  }

  &-pagination-box {
    padding: 30px 0;
  }

  &-fileName {
    width: 400px;
    padding-left: 20px;
    color: #7996f5;
  }
  &-yonghuTags {
    // height: 40px;
    // background: #f8fafd;
    // box-shadow: inset 0 -1px 0 0 #eaeaea;
  }
  &-yonghutag {
    margin-top: 30px;
    width: 800px;
    display: flex;
    justify-content: space-between;
    // height: 40px;
    // display: inline-block;
    // padding: 0 20px;
    // text-align: center;
    // color: #7996f5;
    // line-height: 40px;
    // background: #ffffff;
    // box-shadow: inset -1px 0 0 0 #eaeaea, inset 1px 0 0 0 #eaeaea;
  }
  &-jyyhpjBox {
    position: relative;
    height: 270px;
    padding: 20px 0;
  }
  &-dengji {
    position: absolute;
    top: 35px;
    right: 0;
    width: 150px;
    height: 230px;

    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    background: #f5f6f8;
    border-radius: 2px;
  }
}
.tywrzhz {
  font-size: 14px;
  padding: 0 90px 20px 90px;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
  &-cFiletable {
    width: 100%;
    text-align: center;
    box-shadow: inset 0 -1px 0 0 #e9ebf0, inset -1px 0 0 0 #e9ebf0,
      inset 0 1px 0 0 #e9ebf0, inset 0 1px 0 0 #e9ebf0;
    td {
      height: 36px;
      line-height: 36px;
      box-shadow: inset 1px 0 0 0 #e9ebf0, inset 0 1px 0 0 #e9ebf0;
      a,
      p {
        color: #7996f5;
      }
      a:hover,
      p:hover {
        color: #8ca6fd;
      }
      p {
        cursor: pointer;
      }
    }
  }
  &-tags {
    height: 70px;
    line-height: 70px;
    font-size: 18px;
    background: #ffffff;
    box-shadow: inset 0 -1px 0 0 #eaeaea;
  }
  &-tag {
    display: inline-table;
    margin-right: 35px;
    cursor: pointer;
  }
  &-tag.active {
    color: #7996f5;
    box-shadow: inset 0 -2px 0 0 #7996f5;
  }
  &-infoBox {
    height: 35px;
    line-height: 35px;
    p {
      display: inline-block;
    }
  }
  &-companyInfo {
    padding: 10px 0;
    box-shadow: inset 0 -1px 0 0 #eaeaea;
  }
  &-rzqk {
    padding: 10px 0;
  }
  &-handle {
    color: #7996f5;
    cursor: pointer;
    span {
      margin: 10px;
    }
    span:hover {
      color: #8ca6fd;
    }
  }
  &-lastOrderBox {
    width: 100%;
    border: 1px solid #eaeaea;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  &-head {
    position: relative;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #f8fafd;
    p {
      display: inline-block;
      overflow: hidden;
    }
    p:nth-child(1) {
      width: 230px;
      padding-left: 20px;
      color: #666666;
    }
    p:nth-child(2) {
      width: 340px;
      color: #666666;
    }
    p:nth-child(3) {
      width: 310px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #666666;
    }
    p:nth-child(4) {
      position: absolute;
      top: 5px;
      right: 0;
      width: 120px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background: #7996f5;
      border-radius: 100px 0px 0px 100px;
    }
  }
  &-body {
    width: 100%;
    &-borderBom {
      height: 50px;
      line-height: 50px;
      padding: 0 20px;
      border-bottom: 1px solid #eaeaea;
    }
    &-borderBom:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
.tywjycp {
  margin-top: 20px;
  margin-bottom: 90px;
  font-size: 14px;
  padding: 0 90px 20px 90px;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
}
.whiteFixed {
  position: fixed;
  text-align: center;
  border-top: 1px solid #eaeaea;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: #ffffff;
  z-index: 99;
  margin-top: 70px;
}
.pingjiPopup {
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.5);
  .pingjiBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 385px;
    background: #ffffff;
  }
  &-title {
    position: relative;
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: #40404d;
    font-size: 18px;
    color: #ffffff;
  }
  &-close {
    position: absolute;
    right: 20px;
    font-size: 24px;
    line-height: 70px;
    cursor: pointer;
  }
  &-block {
    width: 440px;
    margin: 0 auto;
  }
  &-des {
    margin: 30px auto 10px auto;
    width: 440px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    background: #d9e2fe;
    border-radius: 4px;
    color: #7996f5;
  }
  &-saveBox {
    box-shadow: inset 0 1px 0 0 #eaeaea;
    margin: 0 auto;
    width: 440px;
    padding: 16px 0;
    height: 38px;
  }
}
.compFilePopup {
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.5);
  &-addFileBox {
    position: absolute;
    color: #81899e;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background: #ffffff;
  }
  &-uploadBox {
    position: relative;
    text-align: center;
    width: 120px;
    height: 34px;
    line-height: 34px;
    border: 1px solid #7996f5;
    color: #7996f5;
    border-radius: 3px;
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 34px;
      opacity: 0;
    }
  }
  &-uploadBox:hover {
    color: #8ca6fd;
  }
  &-title {
    position: relative;
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: #40404d;
    font-size: 18px;
    color: #ffffff;
  }
  &-close {
    position: absolute;
    right: 20px;
    font-size: 24px;
    line-height: 70px;
    cursor: pointer;
  }
  &-block {
    width: 360px;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
    overflow: hidden;
  }
  &-left {
    float: left;
    min-width: 80px;
    padding-right: 20px;
    height: 40px;
    color: #81899e;
    overflow: hidden;
  }
  &-right {
    float: left;
    width: 200px;
    height: 40px;
    display: inline-block;
  }
  .statusEmptyOneLine {
    text-align: center;
    font-size: 14px;
    color: #acb3bb;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

</style>
